import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { clearToken } from "../utils/auth";

const Container = styled.aside`
  width: 320px;
  min-width: 320px;
  min-height: 100dvh;
  background-color: #013566;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
`;

const Logo = styled.img`
  width: 140px;
  height: auto;
`;

const Logout = styled.p`
  color: white;
  font-size: 1.25rem;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  position: fixed;
  left: 7.5rem;
  bottom: 2rem;

  &:hover {
    color: orange;
  }
`;

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: sticky;
  top: 2rem;

  p {
    color: white;
    font-size: 1.25rem;
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;
  }
`;

interface Props {
  setSnackbar: any;
}

const LeftBar: React.FC<Props> = ({ setSnackbar }) => {
  const navigate = useNavigate();

  const logout = () => {
    clearToken();
    setTimeout(() => {
      navigate("/");
    }, 100);
    setSnackbar({
      isOpen: true,
      message: "Logged Out Succesfully",
      severity: "success",
    });
  };
  return (
    <Container>
      <Menu>
        <Logo
          src="/MRG-iQ-White.png"
          alt="MRG-iQ Logo"
        />
        <p onClick={() => navigate("/dashboard")}>Dashboard</p>
        <p onClick={() => navigate("/sweeps")}>Sweeps</p>
        <p onClick={() => navigate("/vendors")}>Vendors</p>
        <p onClick={() => navigate("/clients")}>Clients</p>
        <p onClick={() => navigate("/partners")}>Partners</p>
        <p onClick={() => navigate("/leads")}>Leads</p>
        <p onClick={() => navigate("/verticals")}>Verticals</p>
        <p onClick={() => navigate("/reporting")}>Reporting</p>
        <p onClick={() => navigate("/new-reporting-internal")}>
          Internal Reporting
        </p>
        <p onClick={() => navigate("/myprotectedhome-clicks")}>
          Myprotectedhome Clicks
        </p>
      </Menu>

      <Logout onClick={logout}>Logout</Logout>
    </Container>
  );
};

export default LeftBar;
